import { render, staticRenderFns } from "./AddPlanRecipeForm.vue?vue&type=template&id=1642e503&scoped=true&"
import script from "./AddPlanRecipeForm.vue?vue&type=script&lang=js&"
export * from "./AddPlanRecipeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1642e503",
  null
  
)

export default component.exports